export default {
  namespaced: true,
  state () {
    return {
      papers: [
        {
          id: 'p1',
          authors: 'Swagata Das, Cassie Lowell, Yusuke Kishishita, Kazunori Ogawa, Toshio Tsuji, and Yuichi Kurita',
          title: 'ForceHand glove: a wearable force-feedback glove with pneumatic artificial muscles (PAMs)',
          publisher: 'IEEE Robotics and Automation Letters, 3(3):2416-2423',
          year: 'July 2018.',
          doi: '10.1109/LRA.2018.2813403',
          place: null,
          firstAuthor: false,
          type: 'paper'
        },
        {
          id: 'p2',
          authors: 'Yusuke Kishishita, Kazuhiro Takemura, Naoki Yamada, Toshihiro Hara, Atsuhide Kishi, Kazuo Nishikawa, Takahide Nouzawa, Toshio Tsuji, and Yuichi Kurita',
          title: 'Prediction of Perceived Steering Wheel Operation Force by Muscle Activity',
          publisher: 'IEEE Transactions on Haptics, 11(4):590-598',
          year: 'December 2018.',
          doi: '10.1109/TOH.2018.2828425',
          place: null,
          firstAuthor: true,
          type: 'paper'
        },
        {
          id: 'p3',
          authors: 'Masataka Yamamoto, Yusuke Kishishita, Koji Shimatani, and Yuichi Kurita',
          title: 'Development of New Soft Wearable Balance Exercise Device Using Pneumatic Gel Muscles',
          publisher: 'Applied Sciences, Vol.9, No.15, Article #3108',
          year: 'August 2019.',
          doi: '10.3390/app9153108',
          place: null,
          firstAuthor: false,
          type: 'paper'
        },
        {
          id: 'p4',
          authors: 'Yusuke Kishishita, Yoshihiro Tanaka, Yuichi Kurita',
          title: 'Force perceptual bias caused by muscle activity in unimanual steering',
          publisher: 'PLOS ONE, 14(10): e0223930',
          year: 'October 2019.',
          doi: 'org/10.1371/journal.pone.0223930',
          place: null,
          firstAuthor: true,
          type: 'paper'
        },
        {
          id: 'p5',
          authors: 'Yusuke Kishishita, Toshio Tsuji, and Yuichi Kurita',
          title: 'Effort Cube: a real-time muscle effort visualization system',
          publisher: 'Advances in Robotics',
          year: 'July 2-4, 2015.',
          doi: null,
          place: 'Goa, India',
          firstAuthor: true,
          type: 'conf_i'
        },
        {
          id: 'p6',
          authors: 'Yuichi Kurita, Masaya Kondo, Yusuke Kishishita, and Toshio Tsuji',
          title: 'Human interface design method based on the estimation of muscle effort by a musculoskeletal model',
          publisher: 'IEEE International Conference on Systems, Man, and Cybernetics (SMC2015)',
          year: 'October 10-12, 2015.',
          doi: '10.1109/SMC.2015.95',
          place: 'HongKong, China',
          firstAuthor: false,
          type: 'conf_i'
        },
        {
          id: 'p7',
          authors: 'Yusuke Kishishita, Kazuhiro Takemura, Naoki Yamada, Atsuhide Kishi, Kazuo Nishikawa, Takahide Nouzawa, Toshio Tsuji, and Yuichi Kurita',
          title: 'Computational prediction method of subjective sense of force during steering operation based on muscle activation',
          publisher: 'The 4th International Digital Human Modeling Symposium (DHM2016)',
          year: 'June 15-17, 2016.',
          doi: null,
          place: 'Montreal, Quebec, Canada',
          firstAuthor: true,
          type: 'conf_i'
        },
        {
          id: 'p8',
          authors: 'Yusuke Kishishita, Toshio Tsuji, Yuich Kurita',
          title: 'Computational Prediction of Subjective Sense of Force based on Muscle Activity Estimation',
          publisher: 'The 7th International Conference on Applied Human Factors and Ergonomics 2016',
          year: 'July 27-31, 2016.',
          doi: '10.1007/978-3-319-41694-6_66',
          place: 'Florida, USA',
          firstAuthor: true,
          type: 'conf_i'
        },
        {
          id: 'p9',
          authors: 'Swagata Das, Cassie Lowell, Yusuke Kishishita, Kazunori Ogawa, Toshio Tsuji and Yuichi Kurita',
          title: 'ForceHand glove: a wearable force feedback glove with pneumatic artificial muscles',
          publisher: 'IEEE International Conference on Robotics and Automation (ICRA2018)',
          year: 'May 21-25, 2018.',
          doi: null,
          place: 'Brisbane, Australia',
          firstAuthor: false,
          type: 'conf_i'
        },
        {
          id: 'p10',
          authors: 'Yusuke Kishishita, Antonio Vega Ramirez, Swagata Das, Chetan Thakur, Yohei Yanase, and Yuichi Kurita',
          title: 'Muscleblazer : A wearable laser tag module powered by PAM-induced force-feedback',
          publisher: ' First International Symposium on Amplifying Capabilities, Competing in Mixed Realities (Superhuman Sports Design Challenge)',
          year: 'July 2-5, 2018.',
          doi: null,
          place: 'Delft, Netherlands',
          firstAuthor: true,
          type: 'conf_i'
        },
        {
          id: 'p11',
          authors: 'Yusuke Kishishita, Swagata Das, Antonio Vega Ramirez, Chetan Thakur, Ramin Tadayon, Yuichi Kurita',
          title: 'Muscleblazer: Force-Feedback Suit for Immersive Experience',
          publisher: 'IEEE Conference on Virtual Reality and 3D User Interfaces (IEEE VR): International Workshop on Superhuman Sports',
          year: 'March 24, 2019.',
          doi: null,
          place: 'Osaka, Japan',
          firstAuthor: true,
          type: 'conf_i'
        },
        {
          id: 'p12',
          authors: 'Ramin Tadayon, Antonio Vega Ramirez, Swagata Das, Yusuke Kishishita, Masataka Yamamoto, and Yuichi Kurita',
          title: 'Automatic Exercise Assistance for the Elderly Using Real-Time Adaptation to Performance and Affect',
          publisher: '21st International Conference on Human-Computer Interaction (HCII2019)',
          year: null,
          doi: null,
          place: null,
          firstAuthor: false,
          type: 'conf_i'
        },
        {
          id: 'p13',
          authors: 'Masato Hamada, Yusuke Kishishita Masataka Yamamoto, Yuichi Kurita',
          title: 'Development of aWalking Assist Device with ON-OFF Pattern Control Using Pneumatic Artificial Muscles',
          publisher: 'The SICE Annual Conference 2019',
          year: 'September 10-13, 2019.',
          doi: null,
          place: 'Hiroshima, Japan',
          firstAuthor: false,
          type: 'conf_i'
        },
        {
          id: 'p14',
          authors: 'Wataru Sakoda, Ramin Tadayon, Yusuke Kishishita, Masataka Yamamoto, and Yuichi Kurita',
          title: 'Ski exergame for squat training to change load based on predicted Locomotive risk level',
          publisher: '2020 IEEE/SICE International Symposium on System Integration',
          year: 'January 12-15, 2020.',
          doi: null,
          place: 'Honolulu, Hawaii, USA',
          firstAuthor: false,
          type: 'conf_i'
        },
        {
          id: 'p15',
          authors: 'Masataka Yamamoto, Yusuke Kishishita, Koji Shimatani, Ramin Tadayon, and Yuichi Kurita',
          title: 'Verification of balance function on exercise using a wearable device with pneumatic gel muscles',
          publisher: 'The 1st World Congress on Falls and Postural Stability 2019',
          year: 'December 4-7, 2019.',
          doi: null,
          place: 'Kuala Lumpur, Malaysia',
          firstAuthor: false,
          type: 'conf_i'
        },
        {
          id: 'p16',
          authors: '岸下 優介，辻 敏夫，栗田 雄一',
          title: '筋負担度のリアルタイム可視化システムの構築',
          publisher: '平成26年度日本人間工学会中国・四国支部,関西支部合同大会',
          year: '2014.12.13',
          doi: null,
          place: '岡山',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p17',
          authors: '岸下 優介，辻 敏夫，栗田 雄一',
          title: '筋負担度のリアルタイム可視化システムの構築',
          publisher: '情報処理学会インタラクション2015',
          year: '2015.3.7',
          doi: null,
          place: '東京',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p18',
          authors: '岸下 優介，辻 敏夫，栗田 雄一',
          title: '筋負担度可視化システムの構築',
          publisher: '日本機械学会ロボティクス・メカトロニクス講演会2015',
          year: '2015.5.17-19',
          doi: null,
          place: '京都',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p19',
          authors: '岸下 優介，辻 敏夫，栗田 雄一',
          title: '筋負担度可視化システムの構築',
          publisher: '情報処理学会研究報告グラフィクスとCAD（CG）',
          year: '2015.6.30',
          doi: null,
          place: '広島',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p20',
          authors: '岸下優介，小池祐輝，竹村和紘，山田直樹，新部忠幸，原利宏，岸篤秀，西川一 男，農沢隆秀，辻 敏夫，栗田雄一',
          title: '筋力推定に基づくステアリング操舵における力知覚量設計手法の提案',
          publisher: '第16回計測自動制御学会システムインテグレーション部門講演会 （SI2015）',
          year: '2015.12.14-16',
          doi: null,
          place: '名古屋',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p21',
          authors: '岸下優介, 辻 敏夫, 栗田 雄一',
          title: '筋活動度推定に基づく主観的な力知覚量推定手法',
          publisher: '日本機械学会ロボティクス・メカトロニクス講演会2016',
          year: '2016.6.8-11',
          doi: null,
          place: '横浜',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p22',
          authors: '岸下優介，竹村和紘，山田直樹，原利宏，岸篤秀，西川一男，農沢隆秀，辻敏夫，栗田雄一',
          title: 'ステアリング操舵における筋活動度推定に基づいた力知覚量設計手法の提案',
          publisher: '第17回システムインテグレーション部門講演会(SI2016)',
          year: '2016.15-17',
          doi: null,
          place: '札幌',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p23',
          authors: '岸下優介，辻敏夫，栗田雄一',
          title: '観戦者へのアスリートの筋負担度提示',
          publisher: '超人スポーツ学術研究会',
          year: '2016.12.18',
          doi: null,
          place: '札幌',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p24',
          authors: '栗田雄一，岸下優介，川嶋龍彦，松下欣也，吉川将史',
          title: '把持部の一部を平面にしたペンの操作感に関する考察',
          publisher: 'ロボティクス・メカトロニクス講演会2017',
          year: '2017.5.11-12',
          doi: null,
          place: '郡山',
          firstAuthor: false,
          type: 'conf_j'
        },
        {
          id: 'p25',
          authors: '岸下優介，川嶋龍彦，松下欣也，吉川将史，栗田雄一',
          title: '把持部の一部を平面にしたペンの操作感に対する把持形態の影響',
          publisher: '第18回計測自動制御学会システムインテグレーション部門講演会',
          year: '2017.12.20-22',
          doi: null,
          place: '仙台',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p26',
          authors: 'Yusuke Kishishita, Kazuhiro Takemura, Naoki Yamada, Toshihiro Hara, Atsuhide Kishi, Kazuo Nishikawa, Takahide Nouzawa, Toshio Tsuji, and Yuichi Kurita',
          title: 'Prediction of perceived steering wheel operation force by muscle activity',
          publisher: 'The 3rd Workshop of Robotics Ongoing Breakthroughs (ROOB2018)',
          year: '2018.8.31',
          doi: null,
          place: '大阪',
          firstAuthor: true,
          type: 'conf_j'
        },
        {
          id: 'p27',
          authors: '野嶋 琢也, 持丸 正明, 安藤 良一,岸下 優介',
          title: '【OS】超人スポーツ 超人スポーツ競技の試行的デザイン',
          publisher: '第23回日本バーチャルリアリティ学会',
          year: '2018.9.19-21',
          doi: null,
          place: '仙台',
          firstAuthor: false,
          type: 'conf_j'
        },
        {
          id: 'p28',
          authors: '浜田雅人，岸下優介，山本征孝，栗田雄一',
          title: '人工筋を用いたON-OFFパターン制御による歩行アシスト機器の開発',
          publisher: '日本機械学会ロボティクス・メカトロニクス講演会2019',
          year: '2019.6.6-7',
          doi: null,
          place: '広島',
          firstAuthor: false,
          type: 'conf_j'
        },
        {
          id: 'p29',
          authors: '迫田航, Tadayon Ramin, Vega Ramirez Antonio, Das Swagata, 岸下優介, 山本征孝, 栗田雄一',
          title: '歩行リスクレベルの推定結果に基づき負荷を調整するスクワットトレーニングシステム',
          publisher: '第24回日本バーチャルリアリティ学会大会',
          year: '2019.9.11-13',
          doi: null,
          place: '東京',
          firstAuthor: false,
          type: 'conf_j'
        },
        {
          id: 'p30',
          authors: '岸下優介，栗田雄一',
          title: '人工筋肉による力のアシスト・レジストを用いた主観的重さ感を変化させるハプティックスーツの開発',
          publisher: '第20回計測自動制御学会システムインテグレーション部門講演会',
          year: '2019.12.12-14',
          doi: null,
          place: '高松',
          firstAuthor: false,
          type: 'conf_j'
        }
      ]
    }
  },
  getters: {
    papers (state) {
      return state.papers
    }
  }
}
